export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36')
];

export const server_loads = [2];

export const dictionary = {
		"/[[lang=lang]]/blog": [~5,[2],[3]],
		"/[[lang=lang]]/blog/categories/[slug]": [~7,[2],[3]],
		"/[[lang=lang]]/blog/[slug]": [~6,[2],[3]],
		"/[[lang=lang]]/contact-us": [~8,[2],[3]],
		"/[[lang=lang]]/doctors-near-me": [~9,[2],[3]],
		"/[[lang=lang]]/doctors-near-me/facilities": [~11,[2],[3]],
		"/[[lang=lang]]/doctors-near-me/facilities/[id]": [~12,[2],[3]],
		"/[[lang=lang]]/doctors-near-me/physician/[npi]": [~13,[2],[3]],
		"/[[lang=lang]]/doctors-near-me/practices": [~14,[2],[3]],
		"/[[lang=lang]]/doctors-near-me/practices/[id]": [~15,[2],[3]],
		"/[[lang=lang]]/doctors-near-me/[specialty]": [~10,[2],[3]],
		"/[[lang=lang]]/drugs": [~16,[2],[3]],
		"/[[lang=lang]]/drugs/compare": [~20,[2],[3]],
		"/[[lang=lang]]/drugs/compare/[slugs]": [~21,[2],[3]],
		"/[[lang=lang]]/drugs/conditions/[condition]": [~22,[2],[3]],
		"/[[lang=lang]]/drugs/letter/[letter]": [~23,[2],[3]],
		"/[[lang=lang]]/drugs/[slug]": [~17,[2],[3]],
		"/[[lang=lang]]/drugs/[slug]/images": [~18,[2],[3]],
		"/[[lang=lang]]/drugs/[slug]/savings-card": [~19,[2],[3]],
		"/[[lang=lang]]/help": [~24,[2],[3]],
		"/[[lang=lang]]/help/articles/[slug]": [~26,[2],[3]],
		"/[[lang=lang]]/help/[slug]": [~25,[2],[3]],
		"/[[lang=lang]]/pets": [~27,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[stateabbreviation=state]": [~34,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[stateabbreviation=state]/[city]": [~35,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]": [~28,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[chain]": [~29,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[chain]/discount-card": [~33,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[chain]/[stateabbreviation=state]": [~30,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[chain]/[stateabbreviation=state]/[city]": [~31,[2],[3]],
		"/[[lang=lang]]/pharmacy-near-me/[[service=service]]/[chain]/[stateabbreviation=state]/[city]/[address]/[npi]": [~32,[2],[3]],
		"/[[lang=lang]]/savings-card": [~36,[2],[3]],
		"/[[lang=lang]]/[[slug]]": [~4,[2],[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';